<template>
    <div id="address-book-list-view">
    <a-row>
      <a-col :md="8" :xs="columnWidthSearchBar" class="list-container">
        <action-bar class="search-container" title="Contacts">
            <search-bar/>
        </action-bar>
        <div class="contact-list-container">
            <contact-list/>
        </div>
      </a-col>
      <a-col :md="16" :xs="columnWidthContactDetail">
        <router-view>
            <div style="background:white; height: 100vh; width: 100%;"></div>
        </router-view>
      </a-col>
    </a-row>

    </div>
</template>

<script>
import ActionBar from '@/components/ActionBar'
import SearchBar from '@/components/SearchBar'
import ContactList from '@/components/ContactList'
import ContactDetail from '@/components/ContactDetail'

export default {
  components: {
    ActionBar,
    SearchBar,
    ContactList,
    ContactDetail
  },
  data () {
    return {
      isCreateNewTeamDrawerVisible: false,
      query: null
    }
  },
  mounted () {
    this.$store.dispatch('updateContactList')
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    columnWidthSearchBar () {
      if (this.id) {
        return 0
      }
      return 24
    },
    columnWidthContactDetail () {
      if (this.id) {
        return 24
      }
      return 0
    }
  }
}
</script>

<style scoped>
.list-container {
    max-height: 100vh;
    border-right: 1px solid #e8e8e8;
}
.search-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 150px;
    background: #fcfcff;
}

.contact-list-container {
    margin-top: 150px;
    max-height: calc(100vh - 150px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

</style>



// WEBPACK FOOTER //
// src/components/views/AddressBookList.vue